<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :fill="fill"
       viewBox="0 0 1280 292.53">
    <path d="m640,292.53H0V0c155.13,179.17,384.32,292.53,640,292.53Z"/>
    <path d="m1280,0v292.53h-640c255.68,0,484.87-113.36,640-292.53Z"/>
  </svg>
</template>

<script>
export default {
  name: "SemicircleIcon",
  props: {
    fill: {
      type: String,
      default: '#fff'
    },
  }
}
</script>
